import {Box, Flex, FormLabel} from '@chakra-ui/react';
import React, {useState} from 'react';
import {get} from '../../service/ApiService';
import {OpportunityPlan} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import Select from 'react-select';
import {useQuery} from 'react-query';
import {useClientOpp} from '../../views/Maintenance/OppPlanMaintenance';
import {useSearchParams} from 'react-router-dom';

export default function ClientOMaintenanceSelect() {
  const [searchParams, setSearchParams] = useSearchParams();

  const {selectedClientO, setSelectedClientO} = useClientOpp();
  const [toast, setToast] = useState('');

  const {data, isLoading} = useQuery(['clientO', 'clientOList'], () => get(OpportunityPlan.LIST + '?PageSize=1000'), {
    onError: () => {
      setToast({error: 'Error loading clients'});
    },
  });

  const clients =
    data?.data?.map(client => ({
      value: client?.id,
      clId: client?.clId,
      label: `${client?.clId} ${client?.clLookup ? ' | ' + client.clLookup : ''}`,
    })) ?? [];

  const onChange = (val: any) => {
    setSelectedClientO({id: val.value, clId: val.clId});
    searchParams.set('clientO', val.value);
    searchParams.set('clId', val.clId);
    setSearchParams(searchParams, {replace: true});
  };

  const selectedClient = clients.find(client => client.value === selectedClientO?.id) ?? null;

  return (
    <Flex mr="auto" alignItems="center">
      <FormLabel color="white" fontSize="sm" mb="-0.5" ml="1">
        Select Client
      </FormLabel>
      <Box width={250}>
        <Select value={selectedClient} defaultValue={{}} onChange={onChange} options={clients} isDisabled={clients.length <= 0 || isLoading} />
      </Box>
      <ErrorHelper toastResponse={toast} />
    </Flex>
  );
}
